<template>
  <PModal
    :show="verModalExportar"
    @close="closeExportar"
    :closeClickExit="true"
    :showCloseIcon="true"
    :width="500"
    :height="height"
    :title="textActionName"
  >
    <PCol col="12">
      <section v-if="optionsClientes.length > 1">
        <PFormSelectMulti
          v-model="valueExport.clientesSelected"
          :options="optionsClientes"
          optionValue="id"
          optionText="desCliente"
          :label="$t('label.cliente')"
          :placeholder="$t('label.todos')"
          :scroll="true"
          :showTextOver="true"
        />
      </section>
    </PCol>
    <PCol col="12">
      <PFormSelect
        v-model="valueExport.tipo"
        :options="optionsTipos"
        optionValue="codParametro"
        optionText="desParametro"
        :label="$t('label.tipo')"
        :placeholder="$t('option.select')"
      />
    </PCol>
    <section v-if="!evaluateExportationByOneCliente">
      <PCol md="12">
        <PFormDatepicker
          v-model="valueExport.fechaInicio"
          :label="$t('label.fechaInicio')"
          :endSelector="valueExport.fechaFin"
          :language="locale"
        ></PFormDatepicker>
      </PCol>
      <PCol md="12">
        <PFormDatepicker
          v-model="valueExport.fechaFin"
          :label="$t('label.fechaFin')"
          :startSelector="valueExport.fechaInicio"
          :maxToday="true"
          :maxRangeMonth="maxRange"
          :language="locale"
        ></PFormDatepicker>
      </PCol>
    </section>
    <div class="itemsButtons_PForm buttonAccept">
      <PButton @click="exportarTransferencias" variant="primary">
        {{ $t("action.aceptar") }}
      </PButton>
    </div>
  </PModal>
</template>
<script lang="ts">
import { ICliente, IParametro, ParametroTipoExportacionByOneCliente } from "@/entities";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { Locale } from "@/store";
import VueMethods from "@/vue-methods";
import format from "date-fns/format";
import { MAX_RANGE_MONTH_DATE } from "@/constans";
import { HttpStatusCode } from "axios";

@Component({
  name: "transferencias-exportacion",
  mixins: [VueMethods],
})
export class TransferenciasExportacion extends Vue {
  @Prop({ required: true }) optionsClientes!: ICliente[];
  @Prop({ required: false }) verModalExportar!: boolean;
  @Prop({ required: false }) textActionName!: string;

  @Getter("getClienteSelected") getClienteSelected!: ICliente;
  @Getter("getLocale") locale!: Locale;

  maxRange = MAX_RANGE_MONTH_DATE;
  tiposExportacion: IParametro[] | undefined = [];
  valueExport = {
    clientesSelected: this.getClienteSelected ? [this.getClienteSelected.id] : [],
    tipo:
      this.tiposExportacion && this.tiposExportacion?.length != 0
        ? this.tiposExportacion[0].codParametro
        : "",
    fechaInicio: this.getStartDate(new Date().toISOString()),
    fechaFin: this.getEndDate(new Date().toISOString()),
  };

  async mounted(): Promise<void> {
    await this.obtenerTipos();
    this.resetData();
  }

  resetData(): void {
    if (this.getClienteSelected) {
      this.valueExport.clientesSelected = [this.getClienteSelected.id];
    } else {
      this.valueExport.clientesSelected = [];
    }
    this.valueExport.tipo = "EXCEL";
    this.valueExport.fechaInicio = this.getStartDate(new Date().toISOString());
    this.valueExport.fechaFin = this.getStartDate(new Date().toISOString());
  }

  get optionsTipos(): IParametro[] {
    let tiposExportacionList: IParametro[] = [];
    let clienteSelected: ICliente;
    if (this.valueExport.clientesSelected.length == 1) {
      this.optionsClientes.forEach((cliente) => {
        if (cliente.id == this.valueExport.clientesSelected.at(0)) clienteSelected = cliente;
      });
    }
    this.tiposExportacion?.forEach((tipo) => {
      if (tipo.active) {
        if (ParametroTipoExportacionByOneCliente.includes(tipo.codParametro)) {
          if (clienteSelected && clienteSelected.pais.hasInformeComprasVentas) {
            tiposExportacionList.push(tipo);
          }
        } else {
          tiposExportacionList.push(tipo);
        }
      }
    });
    return tiposExportacionList.sort((a, b) => this.sortAscending(a, b, "desDelegacion"));
  }

  getClienteSelectedByType(): number[] {
    if (ParametroTipoExportacionByOneCliente.includes(this.valueExport.tipo)) {
      const hasMoreThanOneClient =
        this.valueExport.clientesSelected && this.valueExport.clientesSelected.length > 1;
      if (hasMoreThanOneClient) {
        this.$swal({
          title: this.$t("label.advertencia"),
          text: this.$t("label.informeComprasSoloUnCliente"),
          icon: "warning",
          confirmButtonText: this.$t("action.aceptar"),
        });
        this.resetData();
        return [];
      }
    }
    return (this.valueExport.clientesSelected || []).filter(
      (cliente): cliente is number => cliente !== null && cliente !== undefined && cliente !== -1
    );
  }

  async exportarTransferencias(): Promise<void> {
    const clientesSelected: number[] = this.getClienteSelectedByType();

    const fechaInicio = this.valueExport.fechaInicio
      ? format(new Date(this.valueExport.fechaInicio), "yyyy-MM-dd")
      : "";
    const fechaFin = this.valueExport.fechaFin
      ? format(new Date(this.valueExport.fechaFin), "yyyy-MM-dd")
      : "";

    if (this.valueExport.tipo == "EXCEL") {
      this.downloadFile(
        await this.$services.transferencias.getExcelTransferencias(
          clientesSelected,
          fechaInicio,
          fechaFin,
          navigator.language.split("-")[0]
        )
      );
    } else if (this.valueExport.tipo == "PDF") {
      this.downloadFile(
        await this.$services.transferencias.getPdfTransferencias(
          clientesSelected,
          fechaInicio,
          fechaFin,
          navigator.language.split("-")[0]
        )
      );
    } else if (this.valueExport.tipo == "TXT") {
      this.downloadFile(
        await this.$services.transferencias.getTxtTransferencias(
          clientesSelected,
          fechaInicio,
          fechaFin,
          navigator.language.split("-")[0]
        )
      );
    } else if (this.valueExport.tipo == "INFORME_COMPRAS") {
      this.downloadFile(
        await this.$services.transferencias.getInformeComprasTransferencias(
          clientesSelected[0],
          navigator.language.split("-")[0]
        )
      );
    } else if (this.valueExport.tipo == "INFORME_VENTAS") {
      this.downloadFile(
        await this.$services.transferencias.getInformeVentasTransferencias(
          clientesSelected[0],
          navigator.language.split("-")[0]
        )
      );
    } else if (this.valueExport.tipo == "INSTRUCCIONES_COMPRA") {
      const res = await this.$services.transferencias.getCartaInstruccionesCompra(
        clientesSelected[0],
        navigator.language.split("-")[0]
      );
      if (res?.status == HttpStatusCode.Ok) {
        this.downloadFile(res);
      } else {
        this.$swal({
          title: this.$t("label.advertencia"),
          text: this.$t("label.instrucciones_compras.no.content"),
          icon: "warning",
          confirmButtonText: this.$t("action.aceptar"),
        });
      }
    }
    this.closeExportar();
  }

  async obtenerTipos(): Promise<void> {
    this.tiposExportacion = await this.$services.transferencias.fetchTiposExportacion();
    this.tiposExportacion?.forEach((e) => {
      if (ParametroTipoExportacionByOneCliente.includes(e.codParametro)) {
        e.desParametro = this.$t(`label.report_type_excel.${e.desParametro}`);
      }
    });
  }

  closeExportar(): void {
    this.resetData();
    this.$emit("closeExportar");
  }

  get height(): number {
    if (ParametroTipoExportacionByOneCliente.includes(this.valueExport.tipo)) {
      return 320;
    } else {
      return 500;
    }
  }

  get evaluateExportationByOneCliente(): boolean {
    return ParametroTipoExportacionByOneCliente.includes(this.valueExport.tipo);
  }
}
export default TransferenciasExportacion;
</script>
<style scoped>
.buttonAccept {
  padding-bottom: 20px;
  margin-top: 10px;
  padding-right: 10px;
  display: flex;
  flex-direction: row-reverse;
}
</style>
